
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puppy/[id]",
      function () {
        return require("private-next-pages/puppy/[id].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puppy/[id]"])
      });
    }
  